import axios from 'axios'
import router from '../router'
import { Toast } from 'vant'
import Vue from 'vue'
import qs from 'qs' // 根据需求是否导入qs模块
import Cookies from 'js-cookie'

// import { Message } from 'ant-design-vue'
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true

// 线上环境接口地址
if (process.env.NODE_ENV !== 'development') {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
}
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 * !居中显示
 */
const tip = (msg) => {
  Toast.fail({ message: msg })
}
const errorHandle = (other) => {
  // 状态码判断
  switch (other) {
    case '账户查询失败，可能账户不存在或者被封禁，请联系管理员':
      toUrl()
      tip(other)
      break
    case 'nologin':
      toUrl()
      tip('您还未登录，请重新登录！')
      break
    default:
      tip(other)
  }
}
function setExpireTime() {
  let limitDate = new Date(new Date().getTime() + 2 * 60 * 60 * 1000)
  Cookies.set('time', true, { expires: limitDate })
}
function toUrl() {
  delete router.currentRoute.query.code
  delete router.currentRoute.query.state
  let redirectUrl = JSON.stringify(router.currentRoute.query) === '{}' ? router.currentRoute.path : router.currentRoute.path + '?'
  for (let key in router.currentRoute.query) {
    if (redirectUrl.charAt(redirectUrl.length - 1) === '?') {
      redirectUrl += key + '=' + router.currentRoute.query[key]
    } else {
      redirectUrl += '&' + key + '=' + router.currentRoute.query[key]
    }
  }
  localStorage.clear()
  router.replace({
    path: '/login',
    query: {
      redirect: redirectUrl
    }
  })
}
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    /**
     * todo 接口拦截
     * ! 注意路由死循环
     * @description 只有正式环境、正式测试环境才需要走校验逻辑，本地开发不需要校验登录权限
     */
    // if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'productiondevelopment') {
    //   if (!window.sessionStorage.getItem('userInfo')) {
    //     toUrl()
    //   } else setExpireTime()
    // }

    if (config.method === 'post') {
      switch (config.headers['Content-Type']) {
        case 'multipart/form-data':
          // config.data = config.data
          break
        case 'application/x-www-form-urlencoded':
          config.data = qs.stringify(config.data, {
            allowDots: true
          })
          break
        default:
          config.data = JSON.stringify(config.data, {
            allowDots: true
          })
      }
    }
    config.withCredentials = true
    config.headers.csrftoken = localStorage.getItem('CSRFTOKEN')
    return config
  },
  (error) => {
    return Promise.error(error)
  }
)
// 响应拦截器
axios.interceptors.response.use((res) => {
  if (res && res.headers && res.headers.csrftoken) {
    localStorage.setItem('CSRFTOKEN', res.headers.csrftoken)
  }
  if (Object.prototype.hasOwnProperty.call(res.data, 'status')) {
    if (res.data.status) {
      return Promise.resolve(res.data)
    } else {
      errorHandle(res.data.message)
      return Promise.resolve(res.data)
    }
  } else {
    return Promise.resolve(res)
  }
})

/**
 * todo 封装get请求
 */
const get = (url, data, config = {}, source) => {
  if (data && data.http && data.http === 'local') {
    return axios({
      method: 'get',
      url,
      cancelToken: source ? source.token : '' // 每次请求取消凭证;
    })
  } else {
    return axios({
      method: 'get',
      url: url,
      params: data,
      ...config
    })
  }
}

/**
 * todo 封装post请求
 */
const post = (url, data, headers = {}, config = {}, source) => {
  return axios({
    method: 'post',
    url: url,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      ...headers
    },
    ...config,
    withCredentials: true
  })
}

export default {
  get,
  post
}
